import axios from 'axios';
//import { xml2js, js2xml } from 'xml-js'; // Library to help convert between XML and JS objects

const WSDL_URL = "https://api.five9.com:443/wsadmin/v13/AdminWebService";


// Function to send SOAP requests
const sendSoapRequest = async (action, body, username, password) => {
  function toBase64(str) {
    return Buffer.from(str, 'utf-8').toString('base64');
  }

  const credentials = `${username}:${password}`; // Concatenate with a colon
  const encodedCredentials = toBase64(credentials); // Encode to Base64
  const authvalue = "Basic " +  encodedCredentials;

  const headers = {
    'Content-Type': 'text/xml;charset=UTF-8',
    'Authorization': `${authvalue}`
  };

  try {
    // First check CORS
    //await checkCORS(WSDL_URL, username, password);

    const response = await axios.post(WSDL_URL, body, { headers });
    return response.data; // Handle response (this will be XML)
  } catch (error) {
    console.error(`Error in SOAP request: ${error.message}`);
    throw error;
  }
};

// Function to create a SOAP envelope
const createSoapEnvelope = (body) => {
  return `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ser="http://service.admin.ws.five9.com/">
      <soapenv:Header/>
      <soapenv:Body>
        ${body}
      </soapenv:Body>
    </soapenv:Envelope>
  `;
};

// Export the sendSoapRequest for use in other modules
export { sendSoapRequest, createSoapEnvelope };